import React, { Component, useEffect, useState } from "react";
import Form from "../comman/form";
import { Modal, Button } from "react-bootstrap";
import Joi from "joi-browser";
import config from "../config.json";
import Moment from "react-moment";
import { getAlert, getConfirmAlert } from "../services/appAlerts";
import { getWfPhasesColor } from "../services/appService";
import { useDispatch, useSelector } from "react-redux";
import { getPartnerPerformers, getPartnerUsers, getRegisteredPartners, loadPartnerPerformers, loadPartnerPerformersById, loadRegisteredPartners } from "../app/store/partner";
import { getAllRolesPerformers, getAllWorkfllowRoles, getRolePerformers, loadAllWorkflowRoles, loadAllWorkflowRolesPerformers, loadRolePerformers } from "../app/store/workflowRole";
import { getTaskAssignHistory, getTaskAssignStatus, getTaskAssignHistoryLoading, getTaskReAssignLoading, loadTaskReAssignHistory, taskReAssign } from "../app/store/WorkflowEngine";
import { getCurrentUser } from "../app/store/auth";

const TaskReAssignPopup = (props) => {
  const { selectedObj, reAssignShowHide,
    handleReAssignModalShowHide, handleReAssignSubmit } = props;

  const themeClass = selectedObj
    ? (getWfPhasesColor(selectedObj.wfPhase) || "btn-default").replace("btn-", "theme-")
    : "theme-default";

  const performerTypes = [
    {
      id: "WP",
      name: "Main User",
    },
    {
      id: "PP",
      name: "Partner",
    },
  ];

  const state = {
    data: {},
    errors: {},
  };

  const [partners, setPartners] = useState([]);
  const [wfRoles, setWfRoles] = useState([]);
  const [partnerUsers, setPartnerUsers] = useState([]);
  const [wfUsers, setWfUsers] = useState([]);
  const [reAssignHistory, setReAssignHistory] = useState([]);
  const [performerType, setPerformerType] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedPartner, setSelectedPartner] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [notes, setNotes] = useState("");
  const [selectedNotifications, setSelectedNotifications] = useState([]);
  const [selectedKey, setSelectedKey] = useState("reassign");

  const registeredPartnersSelector = useSelector(getRegisteredPartners);
  const taskAssignHistorySelector = useSelector(getTaskAssignHistory);
  const isHistoryLoading = useSelector(getTaskAssignHistoryLoading);
  const allWorkfllowRolesSelector = useSelector(getAllWorkfllowRoles);
  const rolePerformersSelector = useSelector(getRolePerformers);
  const partnerUsersSelector = useSelector(getPartnerUsers);
  const taskAssignStatusSelector = useSelector(getTaskAssignStatus);
  const isReAssignLoading = useSelector(getTaskReAssignLoading);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    dispatch(loadAllWorkflowRoles());
    dispatch(loadRegisteredPartners());
  }, []);

  useEffect(() => {
    if (selectedObj?.wiid) {
      dispatch(loadTaskReAssignHistory(selectedObj.wiid));
      setSelectedKey("reassign");
    }
  }, [selectedObj])

  useEffect(() => {
    if (taskAssignHistorySelector) setReAssignHistory(taskAssignHistorySelector);
  }, [taskAssignHistorySelector]);

  useEffect(() => {
    if (allWorkfllowRolesSelector) setWfRoles(allWorkfllowRolesSelector)
  }, [allWorkfllowRolesSelector])

  useEffect(() => {
    if (registeredPartnersSelector) setPartners(registeredPartnersSelector);
  }, [registeredPartnersSelector]);

  useEffect(() => {
    if (rolePerformersSelector) {
      setWfUsers(rolePerformersSelector.filter((e) => e.status === true));
    }
  }, [rolePerformersSelector]);

  useEffect(() => {
    if (partnerUsersSelector) setWfUsers(partnerUsersSelector);
  }, [partnerUsersSelector]);

  useEffect(() => {
    if (taskAssignStatusSelector) {
      setSelectedPartner("");
      setSelectedRole("");
      setSelectedUser("");
      setPerformerType("");
      setNotes("");
      setSelectedNotifications([])
      getAlert("", "Task Re-Assigned Successfully", "success");
      if (selectedObj?.wiid) dispatch(loadTaskReAssignHistory(selectedObj.wiid));
      handleReAssignSubmit();
    }
  }, [taskAssignStatusSelector])

  const handleRoleChange = ({ currentTarget }) => {
    setSelectedRole(currentTarget.value);
    dispatch(loadRolePerformers(currentTarget.value));
  }

  const handePartnerChange = ({ currentTarget }) => {
    setSelectedPartner(currentTarget.value);
    dispatch(loadPartnerPerformersById(currentTarget.value));
  }

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    setSelectedNotifications((prev) => checked ? [...prev, value] : prev.filter((item) => item !== value));
  };
  // console.log(selectedNotifications, "selnot")
  const handleSubmit = async () => {
    const frmData = new FormData();
    frmData.append("performerType", performerType);
    frmData.append("selectedUser", selectedUser);
    frmData.append("notificationType", JSON.stringify(selectedNotifications));
    frmData.append("notes", notes);
    frmData.append("addedBy", currentUser?.id);
    frmData.append("workflowTask", JSON.stringify(selectedObj));
    const result = await getConfirmAlert("Warning", "Are you sure you want to ReAssign task?", "warning");
    if (result.isConfirmed)
      dispatch(taskReAssign(frmData));
  };

  const btnDisabled = !selectedUser || !performerType;

  if (!reAssignShowHide) return null;

  return (
    <Modal
      show={Boolean(reAssignShowHide)}
      onHide={() => !isReAssignLoading && handleReAssignModalShowHide("")}
      size="xl"
      dialogClassName={`rt-reassign-modal ${themeClass}`}
      backdrop={isReAssignLoading ? "static" : true}
      keyboard={!isReAssignLoading}
      centered
    >
      <style>{`
        /* Ensure the modal and backdrop are on top of sidebars/headers */
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
        }

        /* Glassmorphic backdrop filter and blur */
        .modal-backdrop.show {
          backdrop-filter: blur(8px) !important;
          -webkit-backdrop-filter: blur(8px) !important;
          background-color: rgba(15, 23, 42, 0.45) !important;
          opacity: 1 !important;
        }

        /* Spring-like transition for scale-in animation */
        .modal.fade .rt-reassign-modal.modal-dialog {
          transform: scale(0.95) !important;
          transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
        }
        .modal.show .rt-reassign-modal.modal-dialog {
          transform: scale(1) !important;
        }

        .rt-reassign-modal {
          --task-accent: #2563eb;
          --task-soft: rgba(37, 99, 235, 0.04);
          max-width: 90% !important;
          width: 1200px !important;
        }

        /* Scoped to header only */
        .rt-reassign-modal .modal-header {
          --header-accent: #2563eb;
          --header-soft: rgba(37, 99, 235, 0.04);
        }
        .rt-reassign-modal.theme-primary .modal-header { --header-accent: #3b82f6; --header-soft: #eff6ff; }
        .rt-reassign-modal.theme-info .modal-header { --header-accent: #06b6d4; --header-soft: #ecfeff; }
        .rt-reassign-modal.theme-warning .modal-header { --header-accent: #f59e0b; --header-soft: #fffbeb; }
        .rt-reassign-modal.theme-success .modal-header { --header-accent: #22c55e; --header-soft: #f0fdf4; }
        .rt-reassign-modal.theme-wf2-default .modal-header { --header-accent: #eab308; --header-soft: #fef9c3; }
        .rt-reassign-modal.theme-wf3-default .modal-header { --header-accent: #10b981; --header-soft: #ecfdf5; }
        .rt-reassign-modal.theme-wf4-default .modal-header { --header-accent: #ef4444; --header-soft: #fef2f2; }
        .rt-reassign-modal.theme-wf5-default .modal-header { --header-accent: #f97316; --header-soft: #fff7ed; }
        .rt-reassign-modal.theme-wf6-default .modal-header { --header-accent: #8b5cf6; --header-soft: #f5f3ff; }
        .rt-reassign-modal.theme-default .modal-header,
        .rt-reassign-modal.theme-wf-default .modal-header { --header-accent: #64748b; --header-soft: #f8fafc; }

        .rt-reassign-modal .modal-content {
          border-radius: 12px !important;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
          overflow: hidden !important;
          background: #ffffff !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
        }

        .rt-reassign-modal .modal-header {
          position: relative !important;
          display: block !important;
          padding: 24px 28px 20px 32px !important;
          background: linear-gradient(90deg, var(--header-soft) 0%, rgba(255,255,255,0.98) 54%, #ffffff 100%) !important;
          border-bottom: 1px solid #edf2f7 !important;
          overflow: hidden !important;
        }
        .rt-reassign-modal .modal-header::before {
          content: "" !important;
          position: absolute !important;
          top: -1px !important;
          left: -1px !important;
          bottom: -1px !important;
          width: 5px !important;
          background: var(--header-accent) !important;
          border-radius: 12px 0 0 0 !important;
        }
        .rt-reassign-modal .rt-header-shell {
          display: flex !important;
          flex-direction: column !important;
          gap: 14px !important;
          width: 100% !important;
        }
        .rt-reassign-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: flex-start !important;
          gap: 18px !important;
          width: 100% !important;
        }
        .rt-reassign-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }
        .rt-reassign-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 8px !important;
          min-width: 0 !important;
          padding-top: 4px !important;
        }
        .rt-reassign-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #0f172a !important;
          font-size: 18px !important;
          font-weight: 850 !important;
          line-height: 1.2 !important;
          min-width: 0 !important;
        }
        .rt-reassign-modal .rt-header-icon {
          width: 52px !important;
          height: 52px !important;
          min-height: 52px !important;
          border-radius: 10px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: var(--header-accent) !important;
          background: #ffffff !important;
          border: 1px solid var(--header-accent) !important;
          box-shadow: 0 8px 18px -12px rgba(15,23,42,0.28) !important;
          font-size: 15px !important;
          flex-shrink: 0 !important;
        }
        .rt-reassign-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
          flex-wrap: wrap !important;
        }
        .rt-reassign-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 4px 10px !important;
          border-radius: 999px !important;
          font-size: 10px !important;
          font-weight: 800 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          background: var(--header-soft) !important;
          color: var(--header-accent) !important;
          border: 1px solid #e2e8f0 !important;
        }
        .rt-reassign-modal .rt-modal-meta-row {
          display: flex !important;
          align-items: center !important;
          flex-wrap: wrap !important;
          gap: 10px 12px !important;
          margin-top: 0 !important;
          padding-left: 0 !important;
          font-size: 12px !important;
          color: #64748b !important;
        }
        .rt-reassign-modal .rt-meta-chip {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          background: #ffffff !important;
          padding: 5px 10px !important;
          border-radius: 8px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          border: 1px solid #e2e8f0 !important;
          box-shadow: 0 1px 3px rgba(15,23,42,0.04) !important;
        }
        .rt-reassign-modal .rt-meta-chip i {
          color: var(--task-accent) !important;
          font-size: 11px !important;
        }
        .rt-reassign-modal .rt-meta-divider {
          width: 1px !important;
          height: 16px !important;
          background: #cbd5e1 !important;
          margin: 0 4px !important;
        }

        /* Premium Header Close Button */
        .rt-reassign-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 40px !important;
          height: 40px !important;
          padding: 0 !important;
          font-size: 12px !important;
          font-weight: 700 !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
          outline: none !important;
          font-family: inherit !important;
        }
        .rt-reassign-modal .rt-action-btn:hover {
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          background: #f8fafc !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
        }
        .rt-reassign-modal .rt-action-btn:active {
          transform: translateY(0) !important;
        }
        .rt-reassign-modal .rt-action-btn i {
          font-size: 11px !important;
          color: #94a3b8 !important;
          transition: color 0.2s ease !important;
        }
        .rt-reassign-modal .rt-action-btn:hover i {
          color: #ef4444 !important;
        }

        /* Premium Modal Footer Close Button */
        .rt-reassign-modal .modal-footer {
          background: #f8fafc !important;
          border-top: 1px solid #edf2f7 !important;
          padding: 16px 24px !important;
          display: flex !important;
          justify-content: flex-end !important;
          gap: 12px !important;
        }
        .rt-reassign-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          padding: 9px 20px !important;
          font-size: 13px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
          outline: none !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          font-family: inherit !important;
        }
        .rt-reassign-modal .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
        }
        .rt-reassign-modal .wf-modal-footer-close-btn:active {
          transform: translateY(0) !important;
        }

        .rt-reassign-modal .wf-modal-footer-close-btn:disabled,
        .rt-reassign-modal .rt-action-btn:disabled {
          opacity: 0.55 !important;
          cursor: not-allowed !important;
          pointer-events: none !important;
        }

        .rt-reassign-modal .modal-body {
          padding: 24px !important;
          background: #ffffff !important;
          max-height: calc(100vh - 180px) !important;
          overflow-y: auto !important;
        }

        .rt-reassign-badges {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;
          margin-top: 2px;
        }

        .rt-reassign-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 3px 8px;
          border-radius: 6px;
          font-size: 10px;
          font-weight: 700;
          border: 1px solid transparent;
        }

        .rt-reassign-badge-process {
          background: #ffffff;
          color: #334155;
          border-color: #cbd5e1;
        }

        .rt-reassign-badge-task {
          background: rgba(99, 102, 241, 0.08);
          color: var(--task-accent);
          border-color: rgba(99, 102, 241, 0.2);
        }

        .rt-reassign-badge-label {
          font-weight: 500;
          color: #64748b;
          font-size: 9px;
          text-transform: uppercase;
          letter-spacing: 0.02em;
        }

        .rt-reassign-badge-value {
          color: inherit;
        }

        .rt-notification-group {
          background: #f8fafc !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 8px !important;
          padding: 12px 16px !important;
          display: flex !important;
          flex-direction: column !important;
          gap: 8px !important;
          width: 100% !important;
        }
        .rt-notification-title {
          font-size: 11px !important;
          font-weight: 800 !important;
          color: #475569 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
        }
        .rt-notification-options {
          display: flex !important;
          gap: 16px !important;
        }
        .rt-notification-options .form-check-input {
          cursor: pointer !important;
        }
        .rt-notification-options .form-check-label {
          font-size: 12px !important;
          font-weight: 600 !important;
          color: #334155 !important;
          cursor: pointer !important;
        }

        .rt-reassign-history-section {
          margin-top: 24px !important;
          border-top: 1px solid #f1f5f9 !important;
          padding-top: 20px !important;
        }


        .rt-msg-table-scroll {
          overflow: auto !important;
          max-height: 400px !important;
          position: relative !important;
          scrollbar-width: thin !important;
          scrollbar-color: #94a3b8 #f1f5f9 !important;
          border-radius: 8px !important;
          border: 1px solid #e2e8f0 !important;
        }

        .rt-msg-table {
          width: 100%;
          margin-bottom: 0;
          border: none;
          border-collapse: separate;
          border-spacing: 0;
          color: #1e293b;
        }
        .rt-msg-table thead {
          position: sticky;
          top: 0;
          z-index: 2;
          background: #f8fafc;
        }
        .rt-msg-table thead tr th:first-child {
          border-top-left-radius: 6px !important;
        }
        .rt-msg-table thead tr th:last-child {
          border-top-right-radius: 6px !important;
        }
        .rt-msg-table thead th {
          color: #64748b;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          padding: 12px 16px;
          border-top: none;
          border-bottom: 1.5px solid #edf2f7;
          white-space: nowrap;
          font-family: inherit !important;
        }
        .rt-reassign-modal .rt-msg-table td {
          padding: 12px 16px;
          font-size: 13px;
          color: #334155;
          vertical-align: middle;
          border-top: none;
          border-bottom: 1.5px solid #edf2f7;
          background: transparent !important;
          transition: all 0.15s ease;
          font-family: inherit !important;
        }
        .rt-reassign-modal .rt-msg-table tbody tr:last-child td {
          border-bottom: none;
        }
        .rt-reassign-modal .rt-msg-table tbody tr.rt-msg-row-static {
          transition: background-color 0.15s ease !important;
        }
        .rt-reassign-modal .rt-msg-table tbody tr.rt-msg-row-static:hover td {
          background-color: rgba(37, 99, 235, 0.02) !important;
        }

        .wf-name-cell {
          display: flex !important;
          align-items: center !important;
          gap: 10px !important;
          min-width: 150px !important;
        }
        .wf-name-avatar {
          width: 32px !important;
          height: 32px !important;
          border-radius: 8px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          background: linear-gradient(135deg, rgba(37,99,235,0.12), rgba(20,184,166,0.1)) !important;
          border: 1px solid rgba(37,99,235,0.16) !important;
          color: #1d4ed8 !important;
          font-size: 11px !important;
          font-weight: 800 !important;
          flex-shrink: 0 !important;
        }
        .wf-name-meta {
          display: flex !important;
          flex-direction: column !important;
          gap: 1px !important;
          min-width: 0 !important;
        }
        .wf-name-main {
          font-weight: 700 !important;
          color: #1e293b !important;
          font-size: 13px !important;
          line-height: 1.2 !important;
        }
        .wf-name-title {
          font-size: 11px !important;
          color: #64748b !important;
          font-weight: 500 !important;
          line-height: 1.2 !important;
        }
        .wf-empty-value {
          color: #cbd5e1 !important;
          font-size: 11px !important;
          font-weight: 500 !important;
          line-height: 1.2 !important;
        }

        .rt-msg-time {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-size: 12.5px;
          color: #64748b;
          font-weight: 500;
          white-space: nowrap;
        }
        .rt-msg-time-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          border-radius: 6px;
          background: #f8fafc;
          color: #64748b;
          font-size: 12px;
        }

        .skeleton-row td {
          padding: 12px 16px !important;
        }

        @keyframes loadingBar {
          0%   { width: 0%; opacity: 1; }
          70%  { width: 85%; opacity: 1; }
          100% { width: 100%; opacity: 0; }
        }

        .wf-loading-bar {
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          height: 3px !important;
          background: linear-gradient(90deg, var(--task-accent, #2563eb), #7c3aed, var(--task-accent, #2563eb)) !important;
          background-size: 200% 100% !important;
          animation: loadingBar 1.6s ease-in-out infinite !important;
          z-index: 10 !important;
        }

        @keyframes shimmer {
          0%   { background-position: -600px 0; }
          100% { background-position: 600px 0; }
        }

        .skeleton-cell {
          display: block;
          height: 13px;
          border-radius: 6px;
          background: linear-gradient(
            90deg,
            #f1f5f9 25%,
            #e2e8f0 50%,
            #f1f5f9 75%
          );
          background-size: 600px 100%;
          animation: shimmer 1.4s ease-in-out infinite;
        }

        .skeleton-cell.sk-short  { width: 40%; }
        .skeleton-cell.sk-medium { width: 65%; }
        .skeleton-cell.sk-long   { width: 85%; }
        .skeleton-cell.sk-full   { width: 92%; }

        @keyframes emptyFadeUp {
          from { opacity: 0; transform: translateY(18px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .wf-table-empty {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px 24px;
          text-align: center;
          overflow: hidden;
          background: #ffffff;
          border-radius: 12px;
          margin-top: 12px;
          border: 1.5px solid rgba(99,102,241,0.08);
          animation: emptyFadeUp 0.35s ease both;
        }

        .wf-te-icon-wrap {
          position: relative;
          width: 72px; height: 72px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 16px;
          z-index: 1;
        }

        .wf-te-icon {
          width: 64px; height: 64px;
          border-radius: 14px;
          background: #f8fafc;
          border: 1.5px solid #e2e8f0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: #94a3b8;
          position: relative;
          z-index: 2;
        }

        .wf-te-title {
          font-size: 16px;
          font-weight: 800;
          color: #1e293b;
          margin: 0 0 8px 0;
          line-height: 1.3;
        }

        .wf-te-desc {
          font-size: 13px;
          color: #64748b;
          margin: 0;
          line-height: 1.5;
        }

        .rt-reassign-save-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: var(--task-accent, #2563eb) !important;
          border: 1px solid var(--task-accent, #2563eb) !important;
          padding: 8px 24px !important;
          border-radius: 8px !important;
          font-size: 13px !important;
          font-weight: 700 !important;
          color: #ffffff !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          outline: none !important;
          white-space: nowrap !important;
          font-family: inherit !important;
        }
        .rt-reassign-save-btn:hover:not(:disabled) {
          transform: translateY(-1px) !important;
          opacity: 0.95 !important;
          box-shadow: 0 4px 10px -1px var(--task-accent, rgba(99, 102, 241, 0.25)) !important;
        }
        .rt-reassign-save-btn:active:not(:disabled) {
          transform: translateY(0) !important;
        }
        .rt-reassign-save-btn:disabled {
          opacity: 0.5 !important;
          cursor: not-allowed !important;
        }
        
        .rt-reassign-modal label.form-control-label {
          font-size: 11px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          margin-bottom: 6px !important;
        }
        
        .rt-reassign-modal input[type="text"],
        .rt-reassign-modal select,
        .rt-reassign-modal textarea,
        .rt-reassign-modal .form-control {
          font-size: 12px !important;
          color: #0f172a !important;
          background-color: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 8px !important;
          padding: 8px 12px !important;
          box-shadow: 0 1px 2px rgba(0,0,0,0.05) !important;
          transition: border-color 0.15s ease, box-shadow 0.15s ease !important;
          outline: none !important;
          font-family: inherit !important;
        }
        .rt-reassign-modal input:focus,
        .rt-reassign-modal select:focus,
        .rt-reassign-modal textarea:focus,
        .rt-reassign-modal .form-control:focus {
          border-color: var(--task-accent) !important;
          box-shadow: 0 0 0 3px var(--task-soft), 0 1px 2px rgba(0,0,0,0.05) !important;
          outline: none !important;
        }

        .rt-msg-tab-bar {
          display: flex;
          align-items: stretch;
          gap: 4px;
          border-bottom: 2px solid #f1f5f9;
          margin-bottom: 20px;
          padding: 0 4px;
          position: relative;
        }

        .rt-msg-tab-btn {
          position: relative;
          display: inline-flex;
          align-items: center;
          gap: 7px;
          border: none;
          background: transparent;
          padding: 9px 16px 11px;
          font-size: 13.5px;
          font-weight: 600;
          color: #64748b;
          cursor: pointer;
          border-radius: 8px 8px 0 0;
          transition: color 0.2s ease, background 0.2s ease;
          outline: none;
          white-space: nowrap;
        }
        .rt-msg-tab-btn i {
          font-size: 13px;
          transition: color 0.2s ease;
        }
        .rt-msg-tab-btn:hover {
          color: #1e293b;
          background: rgba(99, 102, 241, 0.04);
        }
        .rt-msg-tab-btn:focus,
        .rt-msg-tab-btn:focus-visible,
        .rt-msg-tab-btn:active {
          outline: none !important;
          box-shadow: none !important;
          border-color: transparent !important;
        }
        .rt-msg-tab-btn.active {
          color: var(--task-accent, #6366f1);
          font-weight: 700;
          background: var(--task-soft, rgba(99, 102, 241, 0.06)) !important;
        }
        .rt-msg-tab-btn.active i {
          color: var(--task-accent, #6366f1);
        }
        .rt-msg-tab-btn::after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 2px;
          background: var(--task-accent, #6366f1);
          border-radius: 2px 2px 0 0;
          transform: scaleX(0);
          transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .rt-msg-tab-btn.active::after {
          transform: scaleX(1);
        }
        .rt-msg-tab-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 20px;
          height: 20px;
          padding: 0 6px;
          border-radius: 999px;
          font-size: 11px;
          font-weight: 700;
          background: #f1f5f9;
          color: #64748b;
          border: 1px solid #e2e8f0;
          line-height: 1;
          transition: all 0.2s ease;
        }
        .rt-msg-tab-btn.active .rt-msg-tab-badge {
          background: var(--task-soft, rgba(99, 102, 241, 0.1));
          color: var(--task-accent, #6366f1);
          border-color: var(--task-accent, rgba(99, 102, 241, 0.2));
        }

        .rt-msg-panel {
          animation: rtMsgTabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both !important;
          flex: 1 1 auto !important;
          min-height: auto !important;
          overflow-y: visible !important;
          overflow-x: hidden !important;
        }
        @keyframes rtMsgTabFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .rt-form-section {
          margin-bottom: 26px !important;
        }
        .rt-section-header {
          display: flex !important;
          align-items: center !important;
          gap: 10px !important;
          margin-bottom: 14px !important;
          padding-bottom: 8px !important;
          border-bottom: 1.5px solid #f1f5f9 !important;
        }
        .rt-section-icon {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 26px !important;
          height: 26px !important;
          border-radius: 7px !important;
          background: var(--task-soft, rgba(37,99,235,0.05)) !important;
          color: var(--task-accent, #2563eb) !important;
          font-size: 12px !important;
        }
        .rt-section-title {
          font-size: 12px !important;
          font-weight: 800 !important;
          color: #334155 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.05em !important;
          margin: 0 !important;
        }
        .rt-section-desc {
          font-size: 11px !important;
          color: #64748b !important;
          font-weight: 500 !important;
          margin-left: auto !important;
          text-transform: none !important;
          letter-spacing: normal !important;
        }

        .rt-perf-type-cards {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 16px;
          margin-top: 4px;
        }

        .rt-perf-type-card {
          position: relative;
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 20px 24px;
          background: #ffffff;
          border: 1.5px solid #cbd5e1;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
          user-select: none;
        }
        .rt-perf-type-card:hover {
          border-color: #94a3b8;
          transform: translateY(-2px);
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.04);
        }
        .rt-perf-type-card.active {
          border-color: var(--task-accent);
          background: var(--task-soft);
          box-shadow: 0 8px 20px -8px rgba(37, 99, 235, 0.15);
        }

        .rt-ptc-icon-wrap {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 46px;
          height: 46px;
          border-radius: 10px;
          background: #f8fafc;
          border: 1px solid #cbd5e1;
          color: #64748b;
          font-size: 20px;
          transition: all 0.2s ease;
          flex-shrink: 0;
        }
        .rt-perf-type-card.active .rt-ptc-icon-wrap {
          background: #ffffff;
          border-color: var(--task-accent);
          color: var(--task-accent);
        }

        .rt-ptc-content {
          display: flex;
          flex-direction: column;
          gap: 4px;
          min-width: 0;
        }
        .rt-ptc-title {
          font-size: 14.5px;
          font-weight: 800;
          color: #0f172a;
        }
        .rt-ptc-desc {
          font-size: 11.5px;
          color: #64748b;
          line-height: 1.4;
        }

        .rt-ptc-badge {
          position: absolute;
          top: 12px;
          right: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: var(--task-accent);
          color: #ffffff;
          font-size: 10px;
          box-shadow: 0 2px 4px rgba(37, 99, 235, 0.2);
        }

        .rt-assignment-card {
          background: #ffffff;
          border: 1px solid #cbd5e1;
          border-radius: 12px;
          padding: 20px 24px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.02) !important;
          animation: rtAssignmentFadeIn 0.3s ease both;
        }
        @keyframes rtAssignmentFadeIn {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .rt-assignment-placeholder {
          border: 2px dashed #cbd5e1 !important;
          border-radius: 12px !important;
          padding: 24px !important;
          text-align: center !important;
          color: #64748b !important;
          background: #f8fafc !important;
          animation: rtAssignmentFadeIn 0.3s ease both !important;
        }
        .rt-assignment-placeholder i {
          font-size: 24px !important;
          color: #94a3b8 !important;
          margin-bottom: 8px !important;
        }
        .rt-assignment-placeholder p {
          font-size: 12.5px !important;
          font-weight: 600 !important;
          margin: 0 !important;
        }

        .rt-input-with-icon {
          position: relative;
          display: flex;
          align-items: center;
        }
        .rt-input-icon {
          position: absolute;
          left: 14px;
          color: #94a3b8;
          font-size: 14px;
          pointer-events: none;
          z-index: 5;
        }

        .rt-reassign-modal select.form-control {
          appearance: none !important;
          -webkit-appearance: none !important;
          -moz-appearance: none !important;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2364748b' stroke-width='2.5'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19.5 8.25l-7.5 7.5-7.5-7.5'/%3E%3C/svg%3E") !important;
          background-repeat: no-repeat !important;
          background-position: right 14px center !important;
          background-size: 12px auto !important;
          padding-left: 38px !important;
          padding-right: 36px !important;
          width: 100% !important;
        }
        .rt-reassign-modal select.form-control:focus {
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%232563eb' stroke-width='2.5'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19.5 8.25l-7.5 7.5-7.5-7.5'/%3E%3C/svg%3E") !important;
        }

        .rt-select-help-text {
          font-size: 11px !important;
          color: #64748b !important;
          margin-top: 5px !important;
          display: block !important;
          font-weight: 500 !important;
        }

        .rt-notif-cards-grid {
          display: grid !important;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)) !important;
          gap: 12px !important;
          margin-top: 4px !important;
        }
        .rt-notif-card {
          position: relative !important;
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          gap: 16px !important;
          padding: 14px 18px !important;
          background: #ffffff !important;
          border: 1.5px solid #cbd5e1 !important;
          border-radius: 10px !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          user-select: none !important;
        }
        .rt-notif-card:hover {
          border-color: #94a3b8 !important;
          background: #f8fafc !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
        }
        .rt-notif-card.active {
          border-color: var(--task-accent) !important;
          background: var(--task-soft) !important;
          box-shadow: 0 4px 12px -2px rgba(37,99,235,0.08) !important;
        }
        .rt-notif-card-main {
          display: flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }
        .rt-notif-card-icon {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 36px !important;
          height: 36px !important;
          border-radius: 8px !important;
          background: #f8fafc;
          border: 1px solid #cbd5e1;
          color: #64748b;
          font-size: 15px;
          transition: all 0.2s ease;
          flex-shrink: 0;
        }
        .rt-notif-card.active .rt-notif-card-icon {
          background: #ffffff !important;
          border-color: var(--task-accent) !important;
          color: var(--task-accent) !important;
        }
        .rt-notif-card-info {
          display: flex !important;
          flex-direction: column !important;
          gap: 2px !important;
          min-width: 0 !important;
        }
        .rt-notif-card-title {
          font-size: 13px !important;
          font-weight: 700 !important;
          color: #1e293b !important;
          line-height: 1.2 !important;
        }
        .rt-notif-card-desc {
          font-size: 10.5px !important;
          color: #64748b !important;
          line-height: 1.3 !important;
          white-space: nowrap !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
        }
        .rt-notif-card.active .rt-notif-card-desc {
          color: #475569 !important;
        }
        .rt-notif-card-toggle {
          position: relative !important;
          width: 36px !important;
          height: 20px !important;
          background: #cbd5e1 !important;
          border-radius: 99px !important;
          transition: background 0.25s ease !important;
          flex-shrink: 0 !important;
        }
        .rt-notif-card.active .rt-notif-card-toggle {
          background: var(--task-accent) !important;
        }
        .rt-toggle-slider {
          position: absolute !important;
          top: 2px !important;
          left: 2px !important;
          width: 16px !important;
          height: 16px !important;
          background: #ffffff !important;
          border-radius: 50% !important;
          transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15) !important;
        }
        .rt-notif-card.active .rt-toggle-slider {
          transform: translateX(16px) !important;
        }

        .rt-quick-tags-container {
          display: flex !important;
          flex-wrap: wrap !important;
          gap: 8px !important;
          margin-bottom: 10px !important;
          align-items: center !important;
        }
        .rt-quick-tag-label {
          font-size: 10px !important;
          font-weight: 700 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          margin-right: 4px !important;
        }
        .rt-quick-tag-badge {
          display: inline-flex !important;
          align-items: center !important;
          padding: 5px 10px !important;
          border-radius: 6px !important;
          font-size: 11px !important;
          font-weight: 600 !important;
          color: #475569 !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          cursor: pointer !important;
          transition: all 0.15s ease !important;
          user-select: none !important;
        }
        .rt-quick-tag-badge:hover {
          color: var(--task-accent) !important;
          border-color: var(--task-accent) !important;
          background: var(--task-soft) !important;
          transform: translateY(-1px) !important;
        }
        .rt-quick-tag-badge:active {
          transform: translateY(0) !important;
        }

        .rt-textarea-wrap {
          position: relative;
        }
        .rt-textarea-icon {
          position: absolute;
          left: 13px;
          top: 11px;
          color: #94a3b8;
          font-size: 13px;
          pointer-events: none;
          line-height: 1;
        }
        .rt-textarea-wrap .form-control {
          padding-left: 38px !important;
        }
      `}</style>

      <Modal.Header>
        <div className="rt-header-shell">
          <div className="rt-header-top">
            <div className="rt-header-main">
              <i className="rt-header-icon fa fa-share" aria-hidden="true" />
              <div className="rt-header-copy">
                <h2 className="rt-modal-title">
                  <span className="rt-modal-title-text">
                    <span>Re-Assign Task</span>
                    {selectedObj?.wfPhase && (
                      <span className="rt-modal-title-badge">
                        {selectedObj.wfPhase}
                      </span>
                    )}
                  </span>
                </h2>
                <div className="rt-modal-meta-row">
                  <span className="rt-meta-chip">
                    <i className="fa fa-tasks" aria-hidden="true" /> Process ID: {selectedObj?.ciid || "N/A"}
                  </span>
                  <span className="rt-meta-chip">
                    <i className="fa fa-info-circle" aria-hidden="true" /> Task: {selectedObj?.itemName || "N/A"}
                  </span>
                </div>
              </div>
            </div>
            <button
              type="button"
              className="rt-action-btn"
              onClick={() => handleReAssignModalShowHide("")}
              disabled={isReAssignLoading}
              title="Close"
            >
              <i className="fa fa-times" aria-hidden="true" />
            </button>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className="rt-msg-tab-bar">
          <button
            type="button"
            className={`rt-msg-tab-btn${selectedKey === "reassign" ? " active" : ""}`}
            onClick={() => setSelectedKey("reassign")}
          >
            <i className="fa fa-share" aria-hidden="true" />
            Re-Assign Form
          </button>
          <button
            type="button"
            className={`rt-msg-tab-btn${selectedKey === "history" ? " active" : ""}`}
            onClick={() => setSelectedKey("history")}
          >
            <i className="fa fa-history" aria-hidden="true" />
            Routing History
            <span className="rt-msg-tab-badge">{reAssignHistory.length}</span>
          </button>
        </div>

        {selectedKey === "reassign" && (
          <div className="rt-msg-panel">
            <div className="row">
              {/* Step 1: Performer Type */}
              <div className="col-md-12 rt-form-section">
                <div className="rt-section-header">
                  <span className="rt-section-icon">
                    <i className="fa fa-user-circle-o" aria-hidden="true" />
                  </span>
                  <h4 className="rt-section-title">1. Performer Type</h4>
                  <span className="rt-section-desc">Select internal staff or external partner</span>
                </div>
                <div className="rt-perf-type-cards">
                  <div
                    className={`rt-perf-type-card${performerType === "WP" ? " active" : ""}`}
                    onClick={() => {
                      setPerformerType("WP");
                      setSelectedRole("");
                      setSelectedPartner("");
                      setSelectedUser("");
                    }}
                  >
                    <div className="rt-ptc-icon-wrap">
                      <i className="fa fa-user-circle-o" aria-hidden="true" />
                    </div>
                    <div className="rt-ptc-content">
                      <span className="rt-ptc-title">Main User</span>
                      <span className="rt-ptc-desc">Assign to an internal staff member or system role</span>
                    </div>
                    {performerType === "WP" && (
                      <div className="rt-ptc-badge">
                        <i className="fa fa-check" aria-hidden="true" />
                      </div>
                    )}
                  </div>

                  <div
                    className={`rt-perf-type-card${performerType === "PP" ? " active" : ""}`}
                    onClick={() => {
                      setPerformerType("PP");
                      setSelectedRole("");
                      setSelectedPartner("");
                      setSelectedUser("");
                    }}
                  >
                    <div className="rt-ptc-icon-wrap">
                      <i className="fa fa-handshake-o" aria-hidden="true" />
                    </div>
                    <div className="rt-ptc-content">
                      <span className="rt-ptc-title">External Partner</span>
                      <span className="rt-ptc-desc">Assign to a subcontractor or external vendor partner</span>
                    </div>
                    {performerType === "PP" && (
                      <div className="rt-ptc-badge">
                        <i className="fa fa-check" aria-hidden="true" />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Step 2: Assignment Details */}
              <div className="col-md-12 rt-form-section">
                <div className="rt-section-header">
                  <span className="rt-section-icon">
                    <i className="fa fa-users" aria-hidden="true" />
                  </span>
                  <h4 className="rt-section-title">2. Assignment Details</h4>
                  {performerType && (
                    <span className="rt-section-desc">
                      {performerType === "WP" ? "Internal Routing Active" : "External Partner Routing Active"}
                    </span>
                  )}
                </div>

                {performerType ? (
                  <div className="rt-assignment-card">
                    <div className="row">
                      {performerType === "WP" && (
                        <div className="col-md-6 form-group">
                          <label htmlFor="selectedRole" className="form-control-label">
                            Select Role
                          </label>
                          <div className="rt-input-with-icon">
                            <i className="fa fa-users rt-input-icon" aria-hidden="true" />
                            <select
                              className="form-control"
                              id="selectedRole"
                              name="selectedRole"
                              value={selectedRole}
                              onChange={handleRoleChange}
                            >
                              <option value="">Select Role</option>
                              {wfRoles.map((p) => (
                                <option key={p.roleid} value={p.roleid}>{p.rolename}</option>
                              ))}
                            </select>
                          </div>
                          <span className="rt-select-help-text">Filters the assignee list by the chosen role</span>
                        </div>
                      )}

                      {performerType === "PP" && (
                        <div className="col-md-6 form-group">
                          <label htmlFor="selectedPartner" className="form-control-label">
                            Select Partner
                          </label>
                          <div className="rt-input-with-icon">
                            <i className="fa fa-briefcase rt-input-icon" aria-hidden="true" />
                            <select
                              name="selectedPartner"
                              id="selectedPartner"
                              className="form-control"
                              value={selectedPartner}
                              onChange={handePartnerChange}
                            >
                              <option value="">Select Partner</option>
                              {partners.map((p) => (
                                <option key={p.fuid} value={p.fuid}>
                                  {p.label} (ID: {p.fuid})
                                </option>
                              ))}
                            </select>
                          </div>
                          <span className="rt-select-help-text">Filters the assignee list by partner company</span>
                        </div>
                      )}

                      <div className="col-md-6 form-group">
                        <label htmlFor="selectedUser" className="form-control-label">
                          Select Assignee {wfUsers.length > 0 && `(${wfUsers.length} available)`}
                        </label>
                        <div className="rt-input-with-icon">
                          <i className="fa fa-user rt-input-icon" aria-hidden="true" />
                          <select
                            className="form-control"
                            id="selectedUser"
                            name="selectedUser"
                            value={selectedUser}
                            onChange={({ currentTarget }) => setSelectedUser(currentTarget.value)}
                          >
                            <option value="">Select Assignee</option>
                            {wfUsers.map((p) => (
                              <option key={p.id} value={p.id}>
                                {p.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <span className="rt-select-help-text">Assigns ownership of this task to user</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="rt-assignment-placeholder">
                    <i className="fa fa-arrow-circle-up" aria-hidden="true" />
                    <p>Select a performer type above to configure assignee options.</p>
                  </div>
                )}
              </div>

              {/* Step 3: Notification Preferences */}
              <div className="col-md-12 rt-form-section">
                <div className="rt-section-header">
                  <span className="rt-section-icon">
                    <i className="fa fa-bell-o" aria-hidden="true" />
                  </span>
                  <h4 className="rt-section-title">3. Notification Preferences</h4>
                  <span className="rt-section-desc">Select how the assignee will be alerted</span>
                </div>
                <div className="rt-notif-cards-grid">
                  <div
                    className={`rt-notif-card${selectedNotifications.includes("Text") ? " active" : ""}`}
                    onClick={() => {
                      const value = "Text";
                      setSelectedNotifications((prev) =>
                        prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
                      );
                    }}
                  >
                    <div className="rt-notif-card-main">
                      <div className="rt-notif-card-icon">
                        <i className="fa fa-envelope-o" aria-hidden="true" />
                      </div>
                      <div className="rt-notif-card-info">
                        <span className="rt-notif-card-title">Email Alert</span>
                        <span className="rt-notif-card-desc">Send notification email to address</span>
                      </div>
                    </div>
                    <div className="rt-notif-card-toggle">
                      <span className="rt-toggle-slider" />
                    </div>
                  </div>

                  <div
                    className={`rt-notif-card${selectedNotifications.includes("Mobile") ? " active" : ""}`}
                    onClick={() => {
                      const value = "Mobile";
                      setSelectedNotifications((prev) =>
                        prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
                      );
                    }}
                  >
                    <div className="rt-notif-card-main">
                      <div className="rt-notif-card-icon">
                        <i className="fa fa-mobile" aria-hidden="true" style={{ fontSize: "16px" }} />
                      </div>
                      <div className="rt-notif-card-info">
                        <span className="rt-notif-card-title">Mobile Push</span>
                        <span className="rt-notif-card-desc">Send push alert to mobile devices</span>
                      </div>
                    </div>
                    <div className="rt-notif-card-toggle">
                      <span className="rt-toggle-slider" />
                    </div>
                  </div>

                  <div
                    className={`rt-notif-card${selectedNotifications.includes("System") ? " active" : ""}`}
                    onClick={() => {
                      const value = "System";
                      setSelectedNotifications((prev) =>
                        prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
                      );
                    }}
                  >
                    <div className="rt-notif-card-main">
                      <div className="rt-notif-card-icon">
                        <i className="fa fa-bell-o" aria-hidden="true" />
                      </div>
                      <div className="rt-notif-card-info">
                        <span className="rt-notif-card-title">System Notice</span>
                        <span className="rt-notif-card-desc">Post a dashboard banner alert for this task</span>
                      </div>
                    </div>
                    <div className="rt-notif-card-toggle">
                      <span className="rt-toggle-slider" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Step 4: Re-Assignment Notes */}
              <div className="col-md-12 rt-form-section mb-0">
                <div className="rt-section-header">
                  <span className="rt-section-icon">
                    <i className="fa fa-commenting-o" aria-hidden="true" />
                  </span>
                  <h4 className="rt-section-title">4. Re-Assignment Notes</h4>
                  <span className="rt-section-desc">Provide context or explanation for routing</span>
                </div>

                <div className="rt-quick-tags-container">
                  <span className="rt-quick-tag-label">Quick Notes:</span>
                  <div
                    className="rt-quick-tag-badge"
                    onClick={() => setNotes("Urgent review required for this task.")}
                  >
                    Urgent Review
                  </div>
                  <div
                    className="rt-quick-tag-badge"
                    onClick={() => setNotes("Assigning for coverage during out-of-office period.")}
                  >
                    OOF Coverage
                  </div>
                  <div
                    className="rt-quick-tag-badge"
                    onClick={() => setNotes("Shift handover. Please follow up on current status.")}
                  >
                    Shift Handover
                  </div>
                  <div
                    className="rt-quick-tag-badge"
                    onClick={() => setNotes("Re-routing to the correct department/role performer.")}
                  >
                    Re-routing
                  </div>
                </div>

                <div className="rt-textarea-wrap">
                  <i className="fa fa-commenting-o rt-textarea-icon" aria-hidden="true" />
                  <textarea
                    cols="3"
                    rows="3"
                    id="notes"
                    className="form-control"
                    placeholder="Provide details about why this task is being re-assigned..."
                    value={notes}
                    onChange={({ currentTarget }) => setNotes(currentTarget.value)}
                    style={{ paddingLeft: "38px" }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {selectedKey === "history" && (
          <div className="rt-msg-panel">
            <div className="row">
              <div className="col-md-12">
                {isHistoryLoading ? (
                  <div className="table-responsive rt-msg-table-scroll">
                    <table className="table align-items-center table-flush rt-msg-table">
                      <thead>
                        <tr style={{ height: "0px", padding: 0 }}>
                          <th colSpan={6} style={{ padding: 0, border: "none", height: "0px", position: "relative" }}>
                            <div className="wf-loading-bar" />
                          </th>
                        </tr>
                        <tr>
                          <th>ID</th>
                          <th>Date & Time</th>
                          <th>Assigned By</th>
                          <th>Route From</th>
                          <th>Route To</th>
                          <th>Notes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.from({ length: 3 }).map((_, i) => (
                          <tr key={`skel-${i}`} className="skeleton-row">
                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                            <td><span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : reAssignHistory.length === 0 ? (
                  <div className="wf-table-empty">
                    <div className="wf-te-icon-wrap">
                      <div className="wf-te-icon">
                        <i className="fa fa-history" aria-hidden="true" />
                      </div>
                    </div>
                    <h3 className="wf-te-title">No Routing History</h3>
                    <p className="wf-te-desc">There is currently no assignment history available for this task.</p>
                  </div>
                ) : (
                  <div className="table-responsive rt-msg-table-scroll">
                    <table className="table align-items-center table-flush rt-msg-table">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Date & Time</th>
                          <th>Assigned By</th>
                          <th>Route From</th>
                          <th>Route To</th>
                          <th>Notes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reAssignHistory.map((item, idx) => {
                          const avatarText = (item.createdBy || "?").split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase();
                          return (
                            <tr key={idx} className="rt-msg-row-static">
                              <td>
                                <span style={{ fontWeight: 600, color: "#64748b", fontSize: "12px" }}>
                                  #{idx + 1}
                                </span>
                              </td>
                              <td>
                                <span className="rt-msg-time">
                                  <span className="rt-msg-time-icon">
                                    <i className="fa fa-calendar-o" aria-hidden="true" />
                                  </span>
                                  <Moment format="MMM D, YYYY h:mm a">{item.assignDateTime}</Moment>
                                </span>
                              </td>
                              <td>
                                <div className="wf-name-cell">
                                  <span className="wf-name-avatar">
                                    {avatarText}
                                  </span>
                                  <div className="wf-name-meta">
                                    <span className="wf-name-main">{item.createdBy || "System"}</span>
                                    <span className="wf-name-title">{item.createdUserType}</span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <span className="rt-routing-performer is-from" style={{ fontWeight: 600, color: "#475569" }}>
                                  {item.fromPerformerName || "Unassigned"}
                                </span>
                              </td>
                              <td>
                                <span className="rt-routing-performer is-to" style={{ fontWeight: 700, color: "var(--task-accent, #2563eb)" }}>
                                  {item.toPerformerName}
                                </span>
                              </td>
                              <td style={{ maxWidth: "250px", whiteSpace: "normal", wordBreak: "break-word" }}>
                                {item.createdNotes ? (
                                  <span style={{ fontSize: "12.5px", color: "#475569" }}>
                                    {item.createdNotes}
                                  </span>
                                ) : (
                                  <span className="wf-empty-value">No notes</span>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="wf-modal-footer-close-btn"
          onClick={() => handleReAssignModalShowHide("")}
          disabled={isReAssignLoading}
        >
          <i className="fa fa-times" aria-hidden="true" /> Close
        </button>
        {selectedKey === "reassign" && (
          <button
            type="button"
            className="btn btn-sm btn-primary rt-reassign-save-btn"
            disabled={btnDisabled || isReAssignLoading}
            onClick={handleSubmit}
          >
            {isReAssignLoading ? (
              <>
                <i className="fa fa-spinner fa-spin mr-2" aria-hidden="true" /> Re-Assigning...
              </>
            ) : (
              <>
                <i className="fa fa-check mr-2" aria-hidden="true" /> Re-Assign Task
              </>
            )}
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default TaskReAssignPopup;
